export const queryKeys = {
  publicPage: (slug, language) => ["publicPage", slug, language],
  publicBlogPosts: (language, options = {}) => [
    "publicBlogPosts",
    language,
    options.home ?? null,
    options.take ?? null,
  ],
  publicBlogPost: (id, language) => ["publicBlogPost", id, language],
};

export const PUBLIC_PAGE_SLUGS = [
  "shared",
  "home",
  "about",
  "law",
  "news",
  "report",
  "report-submitted",
  "track",
];
